export const E__FlexibleReadmoreButton = () => ({
    expanded: false,

    init() {
        this.updateSiblings();
    },

    updateSiblings() {
        // Get the host element
        const hostElement = this.$el;

        // Iterate over the siblings of the host element
        let sibling = hostElement.nextElementSibling;

        while (sibling) {
            // Add a class based on a condition
            if (this.expanded) {
                sibling.classList.remove('not-expanded-sibling');
            } else {
                sibling.classList.add('not-expanded-sibling');
            }
            if (sibling.classList.contains('e--flexible-readmore-button-end')) {
                break;
            }
            sibling = sibling.nextElementSibling;
        }
    },

    toggle() {
        this.expanded = !this.expanded;
        this.updateSiblings();
    }
});
